import { render, staticRenderFns } from "./GigBannerUpload.htm?vue&type=template&id=28c896f9&scoped=true&"
import script from "./GigBannerUpload.js?vue&type=script&lang=js&"
export * from "./GigBannerUpload.js?vue&type=script&lang=js&"
import style0 from "./GigBannerUpload.scss?vue&type=style&index=0&id=28c896f9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c896f9",
  null
  
)

export default component.exports